import * as React from 'react'
// components
import Header from '../components/layouts/Header'
import Footer from '../components/layouts/Footer'
import TeamSection from '../components/sections/Team'

const Team = () => (
  <>
    <div id='smooth-wrapper'>
      <div id='smooth-content'>
        <div className='podio team-wrapper'>
          <TeamSection />
          <Footer />
        </div>
      </div>
    </div>
    <Header />
  </>
)

export default Team
